import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import AddRefuseReason from "../Registration/RefuseReason/addRefuseReason";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import Api from "../../services/api";
import { Redirect } from "react-router-dom";
import AlterReason from "../Registration/RefuseReason/altRefuseReason";
import DelReason from "../Registration/RefuseReason/delRefuseReason";
import {handleColor} from '../../services/Functions'
import ReportReasonsRefuse from "../Reports/reportReasonsRefuse";
class Sidebar extends React.Component {
  state = { data: [], render: false, redirect: false, click: false };

  async componentDidMount() {
    let array = [];
    await Api.get("/refuse-reasons")
      .then((response) => {
        response.data.forEach((element) => {
          array.push({
            Código: element.code,
            Motivos: element.description,
          });
        });
        if (array.length > 0) this.setState({ data: array, render: true });
      })
      .catch((err) => {
        this.setState({ message: "" });
      });
      var viewport = document.querySelector("meta[name=viewport]");
      viewport.setAttribute("content", viewport.content + ", height=" + window.innerHeight);
  }

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

 

  render() {
    const { redirect } = this.state;

    if (redirect) return <Redirect to="/motivos"></Redirect>;

    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{width:'100%',height:'100%'}}>
          <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg1"
                    onClick={handleColor}
                    style={{
                      backgroundColor: "#05ca83",
                      color: "#fff",
                      border: "none",
                    }}
                    className="listGroup"
                    action
                    eventKey="list"
                  >
                    Motivos de refugos
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar Motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar Motivo
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg4"
                    onClick={handleColor}
                    className="listGroup"
                    onClick={() => this.setState({ redirect: true })}
                    eventKey="del"
                  >
                    Paradas
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col className='col3' style={{ top: "5%", marginLeft: "1.5%", width: "100%",height:'78vh', overflow:'auto' }}>
              <Tab.Content>
                <Tab.Pane eventKey="list">
                  <ReportReasonsRefuse />
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddRefuseReason /> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AlterReason /> : null}
                </Tab.Pane>
                <Tab.Pane className='col5' mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelReason /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

function prelude_refugo() {
  return (
    <>
      <div>
        <Top_bar title="Cadastro de Refugos" />{" "}
      </div>
      <div className="prelude_container">
        <Sidebar></Sidebar>
      </div>
      <footer>
        <BottomBar></BottomBar>
      </footer>
    </>
  );
}

export default prelude_refugo;